import { SidebarTrigger } from '@ui/components';
import { useMediaQuery } from '@ui/hooks';
import { cn } from '@ui/utils';
import { FC } from 'react';

export const Header: FC = () => {
  const isMobile = useMediaQuery('MOBILE');

  return <nav className={cn(isMobile && 'mt-2 mb-4')}>{isMobile && <SidebarTrigger />}</nav>;
};
